var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"meta":_vm.meta},model:{value:(_vm.nativeValue),callback:function ($$v) {_vm.nativeValue=$$v},expression:"nativeValue"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }